<template>
  <icon-base
    caption="その他"
    icon="list"
    :action="action"
    route="other"
  />
</template>

<script>
import IconBase from './Base/index'

export default {
  components: {
    IconBase
  },

  methods: {
    action () {
    }
  }
}
</script>
